import { INVOICES_STATES, type InvoicesState } from '../constants.ts';

/** A state the page lists invoices of, the only kind a link or the URL can set the state filter to. */
export const isInvoicesState = (value: unknown): value is InvoicesState => INVOICES_STATES.some((state) => state === value);
